import api from "./index";
import { ENDPOINTS } from "./endpoints";

/**
 * Get the currently active VAT rate
 * @returns {Promise}
 */
export const getActiveVat = () => {
    return api.get(ENDPOINTS.VAT.ACTIVE);
};
